<template>
	<card >
		<div class="relative tw-px-10 job-selection-carousel">
			<div class="glide">
				<div data-glide-el="controls">
					<v-btn
						fab
						depressed
						small
						color="info"
						class="arrow-container nav-button-left custom-button-fab"
						data-glide-dir="<"
					>
						<v-icon dark size="40">keyboard_arrow_left</v-icon>
					</v-btn>
					<v-btn
						fab
						depressed
						small
						color="info"
						class="arrow-container nav-button-right custom-button-fab"
						data-glide-dir=">"
					>
						<v-icon dark size="40">keyboard_arrow_right</v-icon>
					</v-btn>
				</div>
				<div class="glide__track" data-glide-el="track">
					<ul class="glide__slides">
						<job-evaluation-job-card
							v-for="(job) in jobs"
							:job="job"
							:key="job.name"
							:selected="isSelected(job)"
							class="glide__slide"
						/>
					</ul>
				</div>
			</div>
		</div>
	</card>
</template>

<script>
import Card from '@/modules/shared/components/ui/Card/p-card';
import JobEvaluationJobCard from '@/modules/polls/components/custom/JobEvaluationPollPage/JobEvaluationJobCard';
import Glide, { Controls } from '@glidejs/glide/dist/glide.modular.esm';

export default {
	name: 'JobSelectionCarousel',
	components: { JobEvaluationJobCard, Card },
	props: ['jobs', 'selectedJob'],
	methods: {
		isSelected(job) {
			return job.name === this.selectedJob.name;
		},
		glideInit() {
			const glide = new Glide('.glide', {
				type: 'slider',
				perView: 7,
				focusAt: 0,
				breakpoints: {
					800: {
						perView: 3,
					},
					480: {
						perView: 1,
					},
				},
			});

			glide.mount({ Controls });
		},
	},
	watch: {
		jobs: {
			handler() {
				this.$nextTick(() => {
					this.glideInit();
				});
			},
			immediate: true,
		},
	},
};
</script>

<style lang="scss" scoped>
.glide {
	min-height: 150px;
}
.nav-button-left {
	position: absolute;
	left: -80px;
	top: calc(50% - 30px);
}
.nav-button-right {
	position: absolute;
	right: -80px;
	top: calc(50% - 30px);
}
</style>



// WEBPACK FOOTER //
// src/modules/polls/components/custom/JobEvaluationPollPage/JobSelectionCarousel.vue